const isLoggedInElement = document.querySelector('[data-isLoggedIn]')
if (isLoggedInElement) {
  const loggedInData = isLoggedInElement.getAttribute('data-isLoggedIn')
  if (loggedInData) {
    try {
      const loggedInJson = loggedInData.toLowerCase() === 'true'
      window.isLoggedIn = loggedInJson
    } catch (error) {
      console.error('Failed to parse loggedIn data as JSON', error)
    }
  }
}
